import { createFileRoute } from '@tanstack/react-router'
import ExportsPage from '@/pages/ExportsPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/exports')({
    component: ExportsPage,
})
